import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Icons } from '../../utilities/icons';
import { GRID_NAME } from 'src/app/core/constants/common';

@Component({
  selector: 'app-select-channel-dialog',
  templateUrl: './select-channel-dialog.component.html',
  styleUrls: ['./select-channel-dialog.component.scss'],
})
export class SelectChannelDialogComponent implements OnInit {
  icons = Icons;
  channels: Array<any> = [];
  isTemplateGrid = false;

  constructor(
    private readonly dynamicDialogref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.channels = this.config.data.channel;
    if (this.config.data.gridName === GRID_NAME.TEMPLATE_LISTING) {
      // Set to true when 5 channels are present
      this.isTemplateGrid = true;
    }
  }

  channelSelected(channel: string) {
    this.dynamicDialogref.close(channel);
  }
}
